<template>
  <!-- 自定义中国地图组件：embedded 模式下用于大屏中间栏，避免固定 min-height 撑破布局 -->
  <div class="ccm-root" :class="{ 'ccm-root--embedded': embedded }">
    <!-- 全屏切换按钮 -->
    <i @click="toggle" class="el-icon-fullscreen"
       style="cursor:pointer;position:absolute;right: 0px;float: right;z-index: 101;width: 5%;top:9px">
    </i>
    <!-- 全屏容器 -->
    <fullscreen ref="fullscreen" class="ccm-fullscreen-host" @change="fullscreenChange">
      <!-- 地图标题组件 -->
      <div style="position: absolute;z-index: 100; width: 95%">
        <MapTitle :title_text="title_text"
                  :ssxl="this.ssxl==-1?this.title_text['ssxl_val']:this.ssxl"
                  :cfl_new="this.cfl_new==-1?this.title_text['kfl_val']:this.cfl_new"
                  :cfl_old="this.cfl_old==-1?this.title_text['kfl_val']:this.cfl_old"
                  :fees_new="this.fees_new==-1?this.title_text['fee_val']:this.fees_new"
                  :fees_old="this.fees_old==-1?this.title_text['fee_val']:this.fees_old"
                  :key="this.cfl_new || this.params || this.path">
        </MapTitle>
      </div>
      <!-- ECharts 图表容器：非 embedded 保留 min-height 860px 以兼容旧版全屏大屏页 -->
      <div :id="id" :class="className" :style="chartDivStyle"/>
    </fullscreen>

  </div>
</template>

<script>
// 导入 ECharts 图表库
import echarts from 'echarts'
// 导入图表尺寸自适应 mixin
import resize from './mixins/resize'
// 导入地图标题组件
import MapTitle from "@/views/MapTitle";
// 导入全屏插件
import VueFullscreen from 'vue-fullscreen'
import Vue from 'vue'
import { buildAppWebUrl } from '@/utils/appWebUrl'
import { ls3ChartFont } from '@/utils/ls3ChartCompact'
// 注册全屏插件
Vue.use(VueFullscreen)

export default {
  // 混入图表尺寸自适应功能
  mixins: [resize],
  // 注册子组件
  components: {
    MapTitle,
  },
  // 组件属性定义
  props: {
    // 图表容器的 CSS 类名
    className: {
      type: String,
      default: 'chart'
    },
    // 图表容器的唯一标识 ID
    id: {
      type: String,
      default: 'chart'
    },
    // 图表宽度
    width: {
      type: String,
      default: '200px'
    },
    // 图表高度
    height: {
      type: String,
      default: '200px'
    },
    // API 请求路径
    path: {
      type: String
    },
    // 上一个请求路径
    pre_path: {
      type: String
    },
    // 基础请求路径
    base_path: {
      type: String
    },
    // 当前显示的地区（省/市）
    place: {
      type: String,
      default: "中国"
    },
    // 请求参数对象
    params: {},
    /**
     * 是否嵌入三栏大屏中间地图区（为 true 时不设置 min-height:860px，由父级 flex 高度约束）
     */
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  // 组件数据
  data() {
    return {
      // ECharts 图表实例
      chart: null,
      // 当前地区（本地副本，避免直接修改 prop）
      currentPlace: this.place,
      // 当前路径（本地副本，避免直接修改 prop）
      currentPath: this.path,
      // 上一个路径（本地副本，避免直接修改 prop）
      currentPrePath: this.pre_path,
      // 基础路径（本地副本，避免直接修改 prop）
      currentBasePath: this.base_path,
      // 上一个地区
      pre_place: '',
      // 历史导航数据（用于返回上级）
      historyData: [],
      // 标题文本数据
      title_text: '-',
      // 旧处方量
      cfl_old: -1,
      // 新处方量
      cfl_new: -1,
      // 旧费用
      fees_old: -1,
      // 新费用
      fees_new: -1,
      // 实时销量
      ssxl: -1,
      // 是否全屏状态
      fullscreen: false,
      // 定时器 ID
      timer: null,
      itemresult: {
        province: ''
      }
    }
  },
  computed: {
    /**
     * ECharts 容器内联样式：宽度/高度来自 props。
     * embedded（大屏 centerMap）：父链经 flex:1 已有确定高度，用 height:100% 填满；配合 minHeight:0 避免 flex 子项被最小内容高卡住。
     * 非 embedded：沿用 props.height，minHeight 860px 兼容旧全屏页。
     * @returns {{ height: string, width: string, minHeight?: string }}
     */
    chartDivStyle() {
      if (this.embedded) {
        return {
          width: this.width,
          height: '100%',
          minHeight: '0',
        }
      }
      return {
        height: this.height,
        width: this.width,
        minHeight: '860px',
      }
    },
  },
  // 组件挂载后执行
  mounted() {
    // 获取地图 GeoJSON 数据并注册地图
    this.$http.get(process.env.VUE_APP_API_HOST + "/get_map_json_data_v2?name=" + this.place).then((res) => {
      if (res.data.data == "-1") {
        return
      }
      // 注册地图数据到 ECharts
      echarts.registerMap(this.place, res.data.data);
      // 初始化图表
      this.initChart(this.place, this.path, this.params);
    });
  },
  // 组件创建时执行
  created: function () {
    let self = this;
    // 设置定时器：每1分钟刷新一次图表数据
    this.timer = setInterval(() => {
      // this.restart(this.itemresult)
      if (self.chart) {
        self.chart.dispose();
        self.initChart(self.currentPlace, self.currentPath, {...self.params, ...self.itemresult});
      }
    }, 30 * 1000);
  },
  // 组件销毁前执行
  beforeDestroy() {
    // 清除自动更新定时器
    this.cancelAutoUpdate();
    // 销毁图表实例，释放内存
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  // 监听路由变化
  watch: {
    '$route': function (to, from) {
      // 路由改变时重新初始化图表
      if (to != from) {
        this.initChart(this.currentPlace, this.currentPath, this.params);
      }
    },
    // 监听 place prop 变化，同步到本地状态
    place(newVal) {
      this.currentPlace = newVal;
    },
    // 监听 path prop 变化，同步到本地状态
    path(newVal) {
      this.currentPath = newVal;
    },
    // 监听 pre_path prop 变化，同步到本地状态
    pre_path(newVal) {
      this.currentPrePath = newVal;
    },
    // 监听 base_path prop 变化，同步到本地状态
    base_path(newVal) {
      this.currentBasePath = newVal;
    }
  },
  // 组件方法
  methods: {
    /**
     * 取消自动更新定时器
     */
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    /**
     * 切换全屏状态
     */
    toggle() {
      this.$refs['fullscreen'].toggle()
    },
    /**
     * 全屏状态改变回调
     * @param {Boolean} fullscreen - 是否全屏
     */
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen
      // 全屏状态改变时，调整图表尺寸
      if (this.chart) {
        this.$nextTick(() => {
          this.chart.resize()
        })
      }
    },
    /**
     * 重新获取实时处方量和费用数据
     * @param {String} place - 地区名称
     */
    restart(placeData) {
      const data = {
        ...this.params,
        ...placeData,
      }
      // 请求实时处方量和费用数据
      this.$http.post(process.env.VUE_APP_API_HOST + "/get_today_cfl_realtime", data).then((res) => {
        // 更新处方量和费用数据（新值变旧值，新值从接口获取）
        this.cfl_old = (res.data.data.cfl && res.data.data.cfl > 200) ? (res.data.data.cfl - 200) : res.data.data.cfl
        this.cfl_new = res.data.data.cfl
        this.fees_old = this.fees_new
        this.fees_new = res.data.data.fees
        this.ssxl = res.data.data.tiefu
      }).catch((err) => {
        console.error('获取今日处方量失败:', err)
        // 请求失败处理
      })
    },
    /**
     * 初始化图表
     * @param {String} place - 地区名称
     * @param {String} path - API 请求路径
     * @param {Object} params - 请求参数
     */
    initChart(place, path, params) {
      let itemresult = {};
      if (path.indexOf("?") !== -1) {
        // path 中存在 ?，进行切割和参数解析
        let itemData = path.split("?")[1]
        let itemUrl = new URLSearchParams(itemData);
        itemresult = Object.fromEntries(itemUrl);
      } else {
        // path 中不存在 ?，返回 province 为空字符串
        itemresult = {province: place == '中国' ? '' : place};
      }
      this.currentPath = path
      this.itemresult = itemresult;
      // 初始化 ECharts 实例，使用暗色主题
      this.chart = echarts.init(document.getElementById(this.id), 'dark')
      var me = this

      // 监听图表空白区域点击事件（用于返回上级）
      this.chart.getZr().on('click', (param) => {
        console.log('param2----------------------', param)
        // 如果没有点击到具体目标，则返回上一级
        if (!param.target) {
          let place = me.historyData[me.historyData.length - 1].place
          let path = me.historyData[me.historyData.length - 1].path
          me.historyData.pop()
          me.chart.dispose();
          me.currentPlace = place
          me.currentPath = path
          // 刷新实时处方量和费用数据
          // me.restart(itemresult)
          me.initChart(place, path, me.params)
        }
      })

      // 设置图表基础配置
      this.chart.setOption({
        // 图表背景颜色（深色）
        backgroundColor: "#080A20",
        // 工具栏配置
        toolbox: {
          show: true,
          feature: {
            // 隐藏保存图片功能
            saveAsImage: {show: false}
          }
        },
        // 数值范围组件配置（颜色映射条）
        dataRange: {
          show: true,
          text: ['High', 'Low'], // 高值、低值标签
          realtime: true, // 实时更新
          calculable: true, // 可拖拽计算
          // 颜色渐变方案
          color: ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc"]
        },

        // 地理坐标系配置（重点配置区）
        geo: {
          map: place, // 使用注册的地图名称（中国地图或省份地图）
          roam: true, // 允许缩放和平移
          // 如果是中国地图，设置中心点和缩放级别
          center: (place == '中国' ? [106.731761, 38.302601] : null),
          zoom: (place == '中国' ? 1.1 : 1),
          // 标签显示配置
          label: {
            emphasis: { // 高亮状态
              show: true
            },
            normal: { // 普通状态
              show: true
            }
          },
        },
        // 系列数据配置
        series: [{
          type: 'scatter', // 散点图
          coordinateSystem: 'geo' // 使用地理坐标系
        },
          {
            name: '启动次数', // 系列名称（用于提示框标题）
            type: 'map', // 地图类型
            geoIndex: 0, // 使用第一个 geo 组件
            data: [] // 数据（稍后从接口获取）
          }]
      })

      // 请求地图数据
      this.$http.post(process.env.VUE_APP_API_HOST + "/" + path, {...this.params, ...itemresult}).then((res) => {
        this.restart(itemresult)
        // 组件可能已销毁，确保图表实例仍存在
        if (!this.chart) {
          return
        }
        this.chart.hideLoading()
        console.log('res.data.data.ssxl----------------------', res.data.title_subtext_json)
        // 更新标题文本
        this.title_text = {
          clinic_count_val: res.data.title_subtext_json.clinic_count_val,
          select_online_val: res.data.title_subtext_json.select_online_val,
        }

        // 统一的点击事件处理 - 先移除旧的监听器，避免重复绑定
        this.chart.off("click");
        this.chart.on("click", (param) => {
          console.log('param----------------------', param)
          console.log('path----------------------', path)
          // 点击标记点，打开诊所详情页面（所有场景通用）
          if (param.componentType === 'markPoint' || param.seriesType === 'effectScatter') {
            window.open(
              buildAppWebUrl(`/clinic/clinic_info?doctor_id=-1&clinic_id=${param.data.id}`),
              '_blank',
              'noopener,noreferrer'
            );
            return;
          }

          // 根据不同的路径类型，处理地图区域点击
          // 1. 费用总览地图 - 进入省份详情（点击的是省份）
          if (path == "clinic_total_fees") {
            // 点击省份，更新对象为 {province: '省份名称'}
            this.itemresult = {province: param.name}
            // 保存历史记录，用于返回
            this.historyData.push({
              place: place,
              path: path
            })
            this.pre_place = place;
            this.currentPrePath = path;
            this.currentBasePath = path;
            this.currentPlace = param.name
            this.chart.dispose();
            this.currentPath = "show_province_detail_fees?province=" + param.name;
            // 重新初始化图表，显示省份详情
            this.initChart(param.name, this.currentPath, params);
          }
          // 2. 中国地图总览 - 进入省份详情（点击的是省份）
          else if (path == "clinic_china_map") {
            // 点击省份，更新对象为 {province: '省份名称'}
            this.itemresult = {province: param.name}
            this.historyData.push({
              place: place,
              path: path
            })
            this.pre_place = place;
            this.currentPrePath = path;
            this.currentBasePath = path;
            this.currentPlace = param.name;
            this.chart.dispose();
            this.currentPath = "show_province_detail?province=" + param.name;
            // 重新初始化图表，显示省份详情
            this.initChart(param.name, this.currentPath, params);
          }
          // 3. 处方量地图（v2版本）- 需要先获取地图数据（点击的是省份）
          else if (path == "clinic_kfsl_v2") {
            // 对于包含"处方量"文字的标签不允许点击
            if (param.name.indexOf("处方量") != -1) {
              return;
            }
            // 获取省份地图 GeoJSON 数据
            this.$http.get(process.env.VUE_APP_API_HOST + "/get_map_json_data_v2?name=" + param.name).then((res) => {
              if (res.data.data == "-1") {
                return
              }
              // 点击省份，更新对象为 {province: '省份名称'}
              this.itemresult = {province: param.name}
              // 保存历史记录
              this.historyData.push({
                place: place,
                path: path
              })
              this.pre_place = place;
              this.currentPrePath = path;
              this.currentBasePath = path;
              this.currentPlace = param.name;
              this.chart.dispose();
              this.currentPath = "show_province_detail_kfsl_v2?province=" + param.name;
              // 注册省份地图数据
              echarts.registerMap(param.name, res.data.data);
              // 重新初始化图表，显示省份详情
              this.initChart(param.name, this.currentPath, params);
            })
          }
          // 4. 省份详情页 - 进入城市详情或返回全国地图（点击的是城市）
          else if (path.indexOf("show_province_detail") != -1 || path.indexOf("show_province_detail_fees") != -1 || path.indexOf("show_province_detail_kfsl_v2") != -1) {
            // 获取城市地图 GeoJSON 数据
            this.$http.get(process.env.VUE_APP_API_HOST + "/get_map_json_data_v2?name=" + param.name).then((res) => {
              // 如果没有地图数据，返回全国地图
              if (res.data.data == "-1") {
                this.chart.dispose();
                this.pre_place = '';
                this.currentPath = this.currentBasePath;
                this.currentPlace = '中国'
                this.initChart("中国", this.currentPath, params);
                // 返回全国地图时，重置对象
                this.itemresult = {province: ''}
                this.restart(this.itemresult)
                return
              }
              // 点击城市，更新对象为 {province: '省份名称', cityName: '市名称'}
              // place 参数在省份详情页时就是省份名称
              this.itemresult = {
                province: place,
                cityName: param.name
              }
              this.chart.dispose();
              // 保存历史记录
              this.historyData.push({
                place: place,
                path: path
              })
              this.pre_place = place;
              this.currentPrePath = path;
              // 更新路径，添加城市名称参数
              this.currentPath = path + "&cityName=" + param.name
              this.currentPlace = param.name;
              // 注册城市地图数据
              echarts.registerMap(param.name, res.data.data);
              // 重新初始化图表，显示城市详情
              this.initChart(param.name, this.currentPath, params);
            })
          }
        })

        // 使用接口返回的数据更新图表配置（大屏 V3 下整体缩小标题区字号）
        const f = ls3ChartFont
        let options = {
          // 数值范围组件配置（根据实际数据设置最小值和最大值）
          dataRange: {
            show: true,
            min: res.data.min, // 数据最小值
            max: res.data.max, // 数据最大值
            text: ['高', '低'], // 高值、低值标签
            realtime: false, // 不实时更新
            calculable: true, // 可拖拽计算
            // 颜色渐变方案
            color: ["#5470c6", "#91cc75",
              "#fac858", "#ee6666",
              "#73c0de", "#3ba272",
              "#fc8452", "#9a60b4", "#ea7ccc"]
          },
          // 提示框配置
          tooltip: {
            trigger: 'item', // 触发方式：数据项图形触发
            // 自定义提示框内容格式化函数
            formatter: function (params) {
              var res1 = params.name + '<br/>'; // 显示地区名称
              var myseries = res.data.data; // 获取系列数据
              // 遍历所有系列，查找匹配的数据项
              for (var i = 1; i < myseries.length; i++) {
                try {
                  for (var j = 0; j < myseries[i].data.length; j++) {
                    if (myseries[i].data[j].name == params.name) {
                      // 跳过坐标系统数据，只显示具体数值
                      if (!Array.isArray(myseries[i].data[j].value)) {
                        // 如果系列名称是数组（多个指标），显示多个值
                        if (Array.isArray(myseries[i].name)) {
                          res1 += myseries[i].name[0] + ':' + myseries[i].data[j].value + '<br>'
                              + myseries[i].name[1] + ':' + myseries[i].data[j].value1 + '<br>';
                        } else {
                          // 单个指标，显示单个值
                          res1 += myseries[i].name + ':' + myseries[i].data[j].value + '</br>';
                        }
                      }
                    }
                  }
                } catch (error) {
                  console.log(error);
                  // 错误处理
                }
              }
              return res1;
            }
          },
          // 系列数据（从接口返回）
          series: res.data.data,
          // 标题配置
          title: {
            backgroundColor: "#080A20", // 背景颜色
            left: "center", // 居中对齐
            // 副标题样式配置
            subtextStyle: {
              fontSize: f(14),
              rich: { // 富文本样式
                yellow: { // 黄色文字样式
                  fontSize: f(13),
                  color: '#F6F9FA',
                  align: 'center',
                  padding: [3, 3, 3, 3],
                  width: 105
                },
                blue: { // 蓝色文字样式
                  fontSize: f(20),
                  fontWeight: 600,
                  align: 'center',
                  color: '#25F3E6',
                  padding: [3, 3, 3, 3],
                  width: 105
                }
              }
            }
          },
        }
        // 应用配置到图表
        this.chart.setOption(options)
      })
    }
  }
}
</script>

<style scoped>
/* 根节点：嵌入模式下填满父级并裁切溢出，避免地图控制条/图例盖住右侧栏 */
.ccm-root {
  position: relative;
}
/* 嵌入大屏：父级 .chart-container--embedded / .centerMap 提供确定高度，根节点拉满 */
.ccm-root--embedded {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  height: 100%;
  min-height: 0;
  width: 100%;
  min-width: 0;
  overflow: hidden;
}

/* 全屏插件外壳与图表区占满根节点剩余高度 */
.ccm-root--embedded .ccm-fullscreen-host {
  flex: 1 1 0;
  min-height: 0;
  display: flex !important;
  flex-direction: column;
  height: 100% !important;
}
/* 全屏图标样式 */
.el-icon-fullscreen {
  content: url("~@/assets/svgs/full_screen.svg");
}
</style>
